import { Reveal, ChapterLabel } from "./Reveal";
import { SUBJECTS } from "@/data";

export default function FutureClassroom() {
  return (
    <section id="future" data-testid="future-section" className="relative pt-16 sm:pt-24">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-12">
        <ChapterLabel number="10" label="The Future" />
        <Reveal delay={0.1}>
          <h2
            data-testid="future-heading"
            className="mt-6 font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.18] tracking-tight text-[#FFFDF9] max-w-3xl"
          >
            Imagine a classroom where difficult things become{" "}
            <span className="italic text-[#38BDF8]">easier to see</span>.
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="mt-4 max-w-xl text-sm text-slate-400 leading-relaxed">
            AuraXR is envisioned for every subject — not just science. The same classroom, the same
            teacher, a new dimension for every lesson.
          </p>
        </Reveal>
      </div>

      <div className="mx-auto max-w-[1440px] px-6 lg:px-12">
        <Reveal delay={0.2}>
          <div
            data-testid="future-subjects"
            className="no-scrollbar mt-10 flex gap-5 overflow-x-auto pb-2 snap-x snap-mandatory"
            style={{ scrollbarWidth: "none" }}
          >
            {SUBJECTS.map((s, i) => (
              <div
                key={s.id}
                data-testid={`future-subject-${s.id}`}
                className="group relative w-[240px] sm:w-[280px] shrink-0 snap-start cursor-default"
              >
                <div className="overflow-hidden rounded-xl border border-white/[0.08]">
                  <img
                    src={s.img}
                    alt={`${s.name} taught through AuraXR`}
                    loading="lazy"
                    className="aspect-[4/3] w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-[1.05]"
                  />
                </div>
                <p className="mt-3 font-display text-lg text-[#FFFDF9]">
                  <span className="italic text-[#38BDF8]/70 text-sm mr-2">0{i + 1}</span>
                  {s.name}
                </p>
                <p className="mt-1 text-xs text-slate-400 leading-relaxed">{s.desc}</p>
              </div>
            ))}
            <div className="w-2 shrink-0" />
          </div>
        </Reveal>
      </div>

      <div className="mt-14">
        <Reveal delay={0.15}>
          <div className="relative w-screen ml-[calc(50%-50vw)]">
            <div className="relative h-[68vh] min-h-[420px] w-full overflow-hidden">
              <img
                src="/images/future-classroom.jpg"
                alt="A bright Indian classroom of the near future — teacher and students with AuraXR, one anchored 3D heart in the teaching area, blackboard behind"
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover opacity-75"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#050811]/15 via-55% to-[#050811]" />
            </div>

            <div
              className="relative z-10 -mt-40 sm:-mt-60 px-6 text-center"
              data-testid="brand-statement-section"
            >
              <Reveal>
                <p
                  data-testid="brand-statement-line-1"
                  className="font-display text-lg sm:text-xl lg:text-2xl leading-[1.6] tracking-tight text-slate-300 max-w-2xl mx-auto"
                >
                  The future of education isn't about putting a screen in front of every student.
                </p>
              </Reveal>
              <Reveal delay={0.2}>
                <p
                  data-testid="brand-statement-line-2"
                  className="mt-8 font-display text-2xl sm:text-3xl lg:text-4xl leading-[1.5] tracking-tight text-[#FFFDF9] max-w-3xl mx-auto"
                >
                  It's about making{" "}
                  <span className="italic text-[#38BDF8]">understanding visible</span>.
                </p>
              </Reveal>
              <Reveal delay={0.35}>
                <div className="mt-12">
                  <img
                    src="/images/logo-full.png"
                    alt="AuraXR — See beyond. Learn beyond."
                    data-testid="brand-statement-logo"
                    className="mx-auto h-14 sm:h-16 w-auto"
                  />
                  <p className="mt-4 text-[11px] tracking-[0.25em] uppercase text-slate-400">
                    See it. Explore it. Understand it.
                  </p>
                </div>
              </Reveal>
            </div>
          </div>
        </Reveal>
      </div>
      <div className="pb-16 sm:pb-24" />
    </section>
  );
}
